import Constant from '@/const';
import axios from 'axios';

const getPackagesByMenu = async () => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat('/master/package/menu/inventory'),
    );
    return response;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default getPackagesByMenu;
